export function md5 (str, digest = 'hex') {
  return require('crypto').createHash('md5').update(str).digest(digest)
}
